import { ref } from "vue";
import { defineStore } from "pinia";

export const useErrorOverlay = defineStore("errorOverlay", () => {
  /** State **/
  const is_visible = ref<boolean>(false);
  const error_category = ref<string | null>(null);
  const status_code = ref<number | null>(null);

  /** Actions **/
  function show(error_category_: string | null = null, status_code_: number = 400): void {
    console.log(`[error-overlay]: showing error overlay with error category ${error_category_}`);
    error_category.value = error_category_;
    status_code.value = status_code_;
    is_visible.value = true;
  }

  function hide() : void {
    console.log("[error-overlay]: hiding error overlay");
    is_visible.value = false;
    error_category.value = null;
    status_code.value = null;
  }

  function show_timeout(): void {
    console.log("[error-overlay]: showing timeout overlay");
    error_category.value = "TIMEOUT"
    status_code.value = 408;
    is_visible.value = true;
  }

  return {
    is_visible, error_category, status_code,
    show, hide, show_timeout
  }
});
